import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Enroll } from './components/Enroll';
import { SignIn } from './components/SignIn';

import './custom.css'

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Route exact path='/' component={Home} />
                <Route path='/signin' component={SignIn} />
                <Route path='/enroll' component={Enroll} />
            </Layout>
        );
    }
}
